import { Sparkles, CheckCircle2 } from "lucide-react";

export const PremiumPill = ({ label, className = "" }) => (
  <span
    data-testid="premium-ribbon"
    className={`inline-flex items-center gap-0.5 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 text-white text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 shadow-sm ${className}`}
  >
    <Sparkles size={9} /> {label}
  </span>
);

export const PremiumPerks = ({ copy, className = "" }) => (
  <div data-testid="premium-perks" className={`rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white p-3 ${className}`}>
    <p className="text-[11px] font-bold text-amber-700 uppercase tracking-wide flex items-center gap-1 mb-1.5"><Sparkles size={12} /> {copy.title}</p>
    <ul className="space-y-1">
      {copy.items.map((it, i) => (
        <li key={i} className="flex items-start gap-1.5 text-[11px] text-slate-600"><CheckCircle2 size={12} className="text-amber-500 mt-0.5 shrink-0" /> {it}</li>
      ))}
    </ul>
  </div>
);

export const PLACEMENT_VALUES = ["home_top", "home", "browse", "browse_bottom", "browse_sidebar", "listing"];
export const IDEAL_SIZE = { home_top: "1200 × 120 px", home: "1200 × 120 px", browse: "1200 × 120 px", browse_bottom: "1200 × 180 px", browse_sidebar: "600 × 500 px", listing: "600 × 500 px" };
export const STATUS_CLS = {
  live: "bg-emerald-100 text-emerald-700",
  scheduled: "bg-violet-100 text-violet-700",
  expired: "bg-slate-200 text-slate-600",
  paused: "bg-amber-100 text-amber-700",
  pending: "bg-blue-100 text-blue-700",
  rejected: "bg-red-100 text-red-700",
};
export const fmtDate = (v) => v ? new Date(v).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : null;

export const emptyForm = { title: "", image: "", link_url: "", placement: "home", days: 7, start_at: "" };

export const LOAD_CLS = {
  open: "bg-emerald-100 text-emerald-700",
  moderate: "bg-amber-100 text-amber-700",
  busy: "bg-red-100 text-red-700",
};

export const PLACEMENT_RATIO = { home_top: 1200 / 120, home: 1200 / 120, browse: 1200 / 120, browse_bottom: 1200 / 180, browse_sidebar: 600 / 500, listing: 600 / 500 };
export const IDEAL_PX = { home_top: [1200, 120], home: [1200, 120], browse: [1200, 120], browse_bottom: [1200, 180], browse_sidebar: [600, 500], listing: [600, 500] };

const createImage = (url) => new Promise((resolve, reject) => {
  const img = new Image();
  img.addEventListener("load", () => resolve(img));
  img.addEventListener("error", reject);
  img.src = url;
});

export async function getCroppedBlob(src, area, outW, outH) {
  const image = await createImage(src);
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, outW, outH);
  return new Promise((resolve) => canvas.toBlob((b) => resolve(b), "image/jpeg", 0.92));
}
